import * as React from "react";
import {translate} from "react-i18next";
import {Header} from "../../components/Header";
import TextBody from "../../components/TextBody";
import {Container,Row,Col} from "reactstrap";
import BottomBar from "../../components/BottomBar";
import TopNav from "../../components/TopNav";
import moment from "moment";
import {formatDateForBottomBar, getWeekdayFromDate} from "../../DateHelper";
import DayPicker from 'react-day-picker';
import 'react-day-picker/lib/style.css';
import "../../vodafone.css"
import MomentLocaleUtils from 'react-day-picker/moment';
import 'moment/locale/de';
import {SpacerRow} from "../../components/SpacerRow";
import SubPageTopBar from "../../components/SubPageTopBar";
import {BrowserView,MobileView,isMobile} from "react-device-detect";
import TextField from '@material-ui/core/TextField';
import vodafoneLogo from "../../media/icons/vf-logo.png";
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';

class Stage2AppointmentSelectCalendar extends React.Component {

    constructor(props){
        super(props);
        this.handleDayClick = this.handleDayClick.bind(this);

        // set first available date for calendar display

            let firstAvailableDate;
            // use changedDate as firstAvailableDate if given and customerStatus is NOT checked or available (in TT stage; see #389)
            if(props.ds360APIResult && props.ds360APIResult.changedDate && props.ds360APIResult.customerStatus !== "checked" && props.ds360APIResult.customerStatus !== "available"){
                firstAvailableDate = new Date(props.ds360APIResult.changedDate)

            // use first date in availableDates API response array
            } else if(props.availableDates){
                firstAvailableDate = new Date(props.availableDates[0])

            // else: use current date
            } else{
                firstAvailableDate = new Date()
            }
            // console.log( "FNX: firstAvailableDate=");
            // console.log( firstAvailableDate );

        this.initialMonth = firstAvailableDate;

        this.state = {
            selectedDate: firstAvailableDate,
            locale: 'de'
        };
    }

    handleDayClick(day, { selected, disabled }) {
        if(disabled === true){
            return;
        }
        this.setState({
            selectedDate: selected ? undefined : day,
        });
    }

    render() {

		/**
		 * Top Navigation / "Footer" Link
		 */
		const footerLnk = <TopNav
			buttonTextResource={"footer_link"}
			buttonOnClick={this.props.openTopNav}
		/>;

        let bottomBar;
        if(this.state.selectedDate){
            const proposalDate = moment(this.props.ds360APIResult.proposalDate);
        	const isoSelectedDate = moment(this.state.selectedDate)
                        .set("hours", proposalDate.get("hours"))
                        .set("minutes", proposalDate.get("minutes"))
                        .toISOString(false);
        	bottomBar = <BottomBar
                mainButtonOnClick={() => {
                    const proposalDate = moment(this.props.ds360APIResult.proposalDate);
                    const isoSelectedDate = moment(this.state.selectedDate)
                        .set("hours", proposalDate.get("hours"))
                        .set("minutes", proposalDate.get("minutes"))
                        .toISOString(false);
                    this.props.calendarSelectCallback(isoSelectedDate)
                }}
                mainButtonTextResource={"continue"}
                additionalText={"weekday_date"}
                showFullWidth={true}
                weekday={
                    getWeekdayFromDate(this.state.selectedDate)
                }
                date={
                    formatDateForBottomBar(this.state.selectedDate)
                }
            />;
	        console.log( "FNX: stage2-AppointmentSelectCalendar.js bottomBar / mainButtonOnClick / this.state.selectedDate: "); console.log( this.state.selectedDate );
	        console.log( "FNX: stage2-AppointmentSelectCalendar.js bottomBar / mainButtonOnClick / this.props.ds360APIResult.proposalDate: "); console.log( this.props.ds360APIResult.proposalDate );
	        console.log( "FNX: stage2-AppointmentSelectCalendar.js bottomBar / mainButtonOnClick / proposalDate.get(\"hours\"): "); console.log( proposalDate.get("hours") );
	        console.log( "FNX: stage2-AppointmentSelectCalendar.js bottomBar / mainButtonOnClick / isoSelectedDate: "); console.log( isoSelectedDate );
        }

        const calendarPickerContent = <div>
            <SubPageTopBar
                progress={1}
                onClickClose={this.props.onClickClose}
            />
            <SpacerRow/>
            <Header
                textResource={"select_day_title"}
            />
            <SpacerRow/>
            <TextBody
                textResource={"select_day_body"}
            />
            <SpacerRow/>
            <DayPicker
                className={"width-100"}
                localeUtils={MomentLocaleUtils}
                locale={this.state.locale}
                showOutsideDays={true}
                selectedDays={this.state.selectedDate}
                initialMonth={this.initialMonth}
                disabledDays={
                    [
                        { daysOfWeek: [0, 6] },
                        (day) => {
                            const dayMoment = moment(day).format("YYYY-MM-DD");
                            return (this.props.availableDates.indexOf(dayMoment) === -1)
                        }
                    ]
                }
                onDayClick={this.handleDayClick}
            />
<Row>
<Col xs={8} className={"margin-16"}>
    <FormControl className={"width-100"}>
    <RadioGroup>
    <FormControlLabel
value="vormittags" control={<Radio />} label="Vormittags 8-13 Uhr"
    >
    </FormControlLabel>
    <FormControlLabel
value="nachmittags" control={<Radio />} label="Nachmittags 12-17 Uhr"
    >
    </FormControlLabel>
        </RadioGroup>
    </FormControl>
    </Col>
    </Row>
        </div>;

        return <Container fluid={true} style={{backgroundColor:"white",height:"150%"}}>
            <MobileView>
                <Row>
                    <Col xs={2} style={{marginTop:"15px"}}>
                        <img src={vodafoneLogo} className={"img-fluid"}  alt={"Vodafone Logo"}/>
                    </Col>
                    {footerLnk}
                </Row>
                {calendarPickerContent}
                <span className={"fixed-to-bottom fixed-to-bottom-nomargin"}>
                    {bottomBar}
                    <TextField
                        id={"benachrichtigungPer"}
                        type={"hidden"}
                        value={this.props.benachrichtigungPer}
                    />
                </span>
            </MobileView>
            <BrowserView>
                <Container>
                    <Row>
                    {footerLnk}
                    </Row>
                    <Row>
                        <Col sm={{ size: 8, offset: 2 }} md={{ size: 6, offset: 3 }} lg={{ size: 4, offset: 4 }}>
                            {calendarPickerContent}
                            {bottomBar}
                            <TextField
                                id={"benachrichtigungPer"}
                                type={"hidden"}
                                value={this.props.benachrichtigungPer}
                            />
                        </Col>
                    </Row>
                </Container>
            </BrowserView>
        </Container>
    }
}

export default translate("translations")(Stage2AppointmentSelectCalendar);